// material ui components
import Modal from "@mui/material/Modal";
import { useCallback } from "react";

// styles
import styles from "./modal.module.scss";

interface Props {
  showModal: boolean;
  // todo here jsx element is not working need to fix that
  children: any;
  showIcon?: boolean;
  closeModal: () => void;
  header?: string;
}

const ModalComponent = ({
  showModal,
  children,
  showIcon,
  closeModal,
  header = "",
}: Props) => {
  const Header = useCallback(() => {
    return (
      <div className={styles["header"]}>
        <h3 className={"white"}>{header}</h3>
        {showIcon && (
          <img
            alt="lock"
            className={styles.lock}
            src="/assets/images/svg/lock.svg"
          />
        )}

        <img
          onClick={closeModal}
          alt="close-image"
          className={styles["close-image"]}
          src="/assets/images/svg/close.svg"
        />
      </div>
    );
  }, [closeModal, header, showIcon]);

  return (
    <Modal
      className={styles["outer_container"]}
      open={showModal}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}>
      <div className={styles["container"]}>
        <Header />
        {children}
      </div>
    </Modal>
  );
};

export default ModalComponent;
